var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"commonpageheader"},[_c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},[_c('el-breadcrumb-item',{attrs:{"to":{name: 'Subscription'}}},[_vm._v("订阅管理")]),_c('el-breadcrumb-item',[_vm._v("新增订阅")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }